var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWatchLater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 121,
    viewBox: "0 0 127 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.4993 -26.583C43.6035 -26.583 13.416 3.60449 13.416 40.5003C13.416 77.3962 43.6035 107.584 80.4993 107.584C117.395 107.584 147.583 77.3962 147.583 40.5003C147.583 3.60449 117.395 -26.583 80.4993 -26.583ZM80.4993 94.167C50.9156 94.167 26.8327 70.0841 26.8327 40.5003C26.8327 10.9166 50.9156 -13.1663 80.4993 -13.1663C110.083 -13.1663 134.166 10.9166 134.166 40.5003C134.166 70.0841 110.083 94.167 80.4993 94.167ZM83.8535 6.95866H73.791V47.2087L108.674 68.6753L114.041 59.9545L83.8535 41.842V6.95866Z",
    fill: "url(#paint0_linear_7_9326)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_9326",
    x1: 80.4993,
    y1: -26.583,
    x2: 80.4993,
    y2: 107.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323232",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchLater);
export default __webpack_public_path__ + "static/media/watch-later.ae60c9186d4a183da90824612c614a9b.svg";
export { ForwardRef as ReactComponent };